const REQUEST_OUT_OF_STOCK = "REQUEST_OUT_OF_STOCK";
const RECEIVE_OUT_OF_STOCK = "RECEIVE_OUT_OF_STOCK";

export default {
    REQUEST_OUT_OF_STOCK, 
    RECEIVE_OUT_OF_STOCK, 
}